import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {environment} from '../../../environments/environment';
import {captureException} from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class CvrService {

  private httpClient = inject(HttpClient);

  async getCompanyInfoByCVR(cvr: string, country: string): Promise<any | undefined> {
    let params: HttpParams = new HttpParams();
    params = params.append('search', cvr);
    params = params.append('country', country);
    return await firstValueFrom(this.httpClient.get(environment.cvrapi.url, {params: params}))
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorObj = new Error(`Message: ${error.message}, Status: ${error.status}, URL: ${error.url}`);
        errorObj.name = 'Error fetching company info';
        captureException(errorObj);
        return undefined;
      });
  }
}
